'use strict';

(function () {
    //Constants
    const BGN_TO_EUR = 0.51;
    const PRICE_REGEX = /\b(?:Lv\s+(\d+(?:[.,]\d+)?)|(\d+(?:[.,]\d+)?)\s+Lv)\b/gi;

    // Utility functions
    const parsePrice = (price) => parseFloat(price.replace(',', '.'));

    const formatEurPrice = (amount, originalPrice) => {
        const formatted = (amount * BGN_TO_EUR).toFixed(2);
        return formatted.replace('.', originalPrice.includes(',') ? ',' : '.');
    };

    const convertPriceText = (textNode) => {
        const parent = textNode.parentNode;
        if (!parent || parent.classList.contains('bgn-price-wrapper')) {return;}

        const text = textNode.textContent.trim();

        // Skip if already contains EUR conversion
        if (text.includes('€') || text.includes('EUR')) {return;}

        const matches = text.match(PRICE_REGEX);

        // Check if text contains only the price (standalone)
        const isStandalone = matches && matches.length === 1 && text === matches[0];

        if (isStandalone) {
            // Handle standalone price
            const match = matches[0];
            const [, prefixPrice, suffixPrice] = PRICE_REGEX.exec(text);
            const price = prefixPrice || suffixPrice;
            const eurPrice = formatEurPrice(parsePrice(price), price);

            const el = document.createElement('span');
            el.textContent = match;
            el.style.position = 'relative';
            el.className = 'bgn-price-wrapper';

            const eurDiv = document.createElement('div');
            eurDiv.textContent = `€ ${eurPrice}`;

            el.appendChild(eurDiv);
            parent.replaceChild(el, textNode);
        } else {
            // Handle inline text replacement
            const fragment = document.createDocumentFragment();
            let lastIndex = 0;
            let hasMatches = false;

            text.replace(PRICE_REGEX, (match, prefixPrice, suffixPrice, offset) => {
                const price = prefixPrice || suffixPrice;
                const eurPrice = formatEurPrice(parsePrice(price), price);

                // Add text before match
                if (offset > lastIndex) {
                    fragment.appendChild(document.createTextNode(text.slice(lastIndex, offset)));
                }

                // Add inline replacement
                fragment.appendChild(document.createTextNode(`${match} / €${eurPrice}`));

                lastIndex = offset + match.length;
                hasMatches = true;
            });

            // Add remaining text
            if (lastIndex < text.length) {
                fragment.appendChild(document.createTextNode(text.slice(lastIndex)));
            }

            // Replace original text node only if we made changes
            if (hasMatches) {
                parent.replaceChild(fragment, textNode);
            }
        }
    };

    const isTextNode = (node) => node.nodeType === 3;
    const isElementNode = (node) => node.nodeType === 1;
    const hasPricePattern = (text) => PRICE_REGEX.test(text);

    // Processing functions
    const processedNodes = new WeakSet();

    const processTextNode = (textNode) => {
        if (!isTextNode(textNode) || processedNodes.has(textNode)) {return;}

        const original = textNode.textContent;
        if (!hasPricePattern(original)) {return;}

        convertPriceText(textNode);
        processedNodes.add(textNode);
    };

    const processElement = (element) => {
        if (!isElementNode(element)) {return;}

        const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT, null);
        let node;
        while ((node = walker.nextNode())) {
            processTextNode(node);
        }
    };

    const processNode = (node) => {
        if (isTextNode(node)) {
            processTextNode(node)
        } else {
            processElement(node);
        }
    };

    // Observers
    const intersectionObserver = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    processNode(entry.target);
                }
            });
        },
        {threshold: 0.1}
    );

    const mutationObserver = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            mutation.addedNodes.forEach((node) => {
                processNode(node);
                if (isElementNode(node)) {
                    intersectionObserver.observe(node);
                    node.querySelectorAll('*').forEach((child) => intersectionObserver.observe(child));
                }
            });
        });
    });

    const init = () => {
        processNode(document.body);

        mutationObserver.observe(document.body, {childList: true, subtree: true});
        document.querySelectorAll('*').forEach((el) => intersectionObserver.observe(el));
    };

    // Cleanup function to disconnect observers
    const cleanup = () => {
        mutationObserver.disconnect();
        intersectionObserver.disconnect();
    };

    // Exportable object
    const converterBgnEur = {
        init,
        cleanup,
        parsePrice,
        formatEurPrice,
        convertPriceText,
        isTextNode,
        isElementNode,
        hasPricePattern,
    };

    if (typeof module !== 'undefined' && module.exports) {
        module.exports = converterBgnEur;
    } else {
        window.converterBgnEur = converterBgnEur; // If in a browser environment without modules
    }
})();
